// ============================================================
// Blank Layout — Full-page layout for 404, Unauthorized
// ============================================================

import { Box } from '@mui/material';
import { Outlet } from 'react-router-dom';
import { tokens } from '@/theme/tokens';

export function BlankLayout() {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: tokens.colors.background,
        px: 2,
      }}
    >
      <Outlet />
    </Box>
  );
}
